import React from 'react';
import Hero from "../../common/Hero";
import Footer from '../../common/Footer';
import BlogImage from '../../assests/images/blog.jpg';
import Slider from 'react-slick';
import Navbar from "../../common/Navbar";

// ✅ Online image URLs (royalty-free: Unsplash / Pixabay)
const mediaItems = [
  // Blinds
  { type: 'image', src: 'https://images.unsplash.com/photo-1527251281321-ffa074af0b2c?auto=format&fit=crop&w=1000&q=80' },
  { type: 'image', src: 'https://images.unsplash.com/photo-1598300084405-5f626c5fff24?auto=format&fit=crop&w=1000&q=80' },
  { type: 'image', src: 'https://images.unsplash.com/photo-1598300050313-bc96dad5933d?auto=format&fit=crop&w=1000&q=80' },
  { type: 'image', src: 'https://images.unsplash.com/photo-1616627987999-6cc6e10ce8c2?auto=format&fit=crop&w=1000&q=80' },
  { type: 'image', src: 'https://images.unsplash.com/photo-1597804276272-f3f2f0f9d45a?auto=format&fit=crop&w=1000&q=80' },

  // Carpets
  { type: 'image', src: 'https://images.unsplash.com/photo-1603570419960-59a2c38ac26b?auto=format&fit=crop&w=1000&q=80' },
  { type: 'image', src: 'https://images.unsplash.com/photo-1625591342706-c77fbcf810f2?auto=format&fit=crop&w=1000&q=80' },
  { type: 'image', src: 'https://images.unsplash.com/photo-1622198821276-04657c769a7a?auto=format&fit=crop&w=1000&q=80' },
  { type: 'image', src: 'https://pixabay.com/get/gd7ffe73ad559a992f9d7b6f93f5c7be0d8c10aeb752d390aaa227744f48e1032e8c5efab85d50afa2dae366b379957ad_1280.jpg' },
  { type: 'image', src: 'https://pixabay.com/get/g6a33f8c0523fa9f28f6f9ba6ccf51dc4dbed0a0d61c7a7069ea7e3a178288a66c689f056bb7a8f1e67de16b00f26b984_1280.jpg' },
];

const Gallery = () => {
  // Main slider
  const mainSliderSettings = {
    dots: false,
    infinite: true,
    speed: 600,
    autoplay: true,
    autoplaySpeed: 1800,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
  };

  // Secondary slider
  const secondarySliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 1500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <>
      <Navbar />
      <Hero text="Gallery" text1="Our Work" image={BlogImage} />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Page Title */}
        <h1 className="text-3xl md:text-5xl text-gray-800 font-bold text-center my-8">
          MF Carpet and Blinds Gallery
        </h1>
        <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
          Explore our range of carpet installations and blinds fittings — crafted with care, style, and precision to enhance every space.
        </p>

        {/* Main Slider */}
        <div className="mb-12">
          <Slider {...mainSliderSettings}>
            {mediaItems.map((item, index) => (
              <div key={index} className="cursor-pointer">
                {item.type === 'image' ? (
                  <img
                    src={item.src}
                    alt={`MF Carpet and Blinds Project ${index + 1}`}
                    className="w-full h-[500px] object-cover rounded-2xl shadow-lg transition-transform duration-300 ease-in-out transform hover:scale-105"
                    loading="lazy"
                  />
                ) : (
                  <video
                    src={item.src}
                    className="w-full h-[500px] object-cover rounded-2xl shadow-lg transition-transform duration-300 ease-in-out transform hover:scale-105"
                    controls
                  ></video>
                )}
              </div>
            ))}
          </Slider>
        </div>

        {/* Secondary Slider */}
        <div>
          <h2 className="text-2xl md:text-4xl text-gray-800 font-semibold text-center mb-8">
            More of Our Work
          </h2>
          <Slider {...secondarySliderSettings}>
            {mediaItems.map((item, index) => (
              <div key={index} className="px-2">
                {item.type === 'image' ? (
                  <img
                    src={item.src}
                    alt={`MF Carpet and Blinds Gallery ${index + 1}`}
                    className="w-full h-64 object-cover rounded-xl shadow-md transition-transform duration-300 ease-in-out transform hover:scale-105"
                    loading="lazy"
                  />
                ) : (
                  <video
                    src={item.src}
                    className="w-full h-64 object-cover rounded-xl shadow-md transition-transform duration-300 ease-in-out transform hover:scale-105"
                    controls
                  ></video>
                )}
              </div>
            ))}
          </Slider>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Gallery;
